type LogLevel = 'debug' | 'info' | 'warn' | 'error';
type LogData = Record<string, unknown>;

class Logger {

  log(message: string, level: LogLevel = 'info', data?: LogData) {
    if (process.env.NODE_ENV === 'development') {
      const logMethod = console[level] || console.log;

      if (data && Object.keys(data).length > 0) {
        logMethod(`[${level.toUpperCase()}] ${message}`, data);
      } else {
        logMethod(`[${level.toUpperCase()}] ${message}`);
      }
    }
  }

  debug(message: string, data?: LogData) {
    this.log(message, 'debug', data);
  }

  info(message: string, data?: LogData) {
    this.log(message, 'info', data);
  }

  warn(message: string, data?: LogData) {
    this.log(message, 'warn', data);
  }

  error(message: string, data?: LogData) {
    this.log(message, 'error', data);
  }

}

export const logger = new Logger();
